/**
 * Cosmetics — Pon Pon costumes (element-free; persist through element colour
 * changes in-game). Mirrors the prototype's `COSTUMES` list in
 * `docs/design/flow/ui.jsx`.
 */
export const COSTUMES = [
    { id: 'classic', label: 'Classic', tint: '#eaf3ff' },
    { id: 'straw', label: 'Straw Hat', tint: '#ffe7b0' },
    { id: 'crown', label: 'Crown', tint: '#ffeccb' },
    { id: 'bow', label: 'Ribbon', tint: '#ffd6e0' },
    { id: 'leaf', label: 'Sprout', tint: '#d8f0bf' },
    { id: 'goggles', label: 'Goggles', tint: '#cfeaff' },
    { id: 'flower', label: 'Flower', tint: '#eedcff' },
    { id: 'cap', label: 'Cap', tint: '#bfe6d2' },
];
export const DEFAULT_COSTUME = 'classic';
/** Look up a costume's default tint; falls back to the classic tint. */
export function costumeTint(id) {
    return COSTUMES.find((c) => c.id === id)?.tint ?? '#eaf3ff';
}
//# sourceMappingURL=cosmetics.js.map